import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {},
		itemNumber: {
			color: theme.palette.text.secondary,
		},
		button: {
			backgroundColor: theme.palette.background.default,
			color: theme.palette.text.secondary,
			borderBottom: `1px solid ${theme.palette.text.secondary}`,
			paddingBottom: theme.spacing(1.5),
			paddingTop: theme.spacing(1.5),
			paddingLeft: 0,
			borderRadius: 0,
			minHeight: theme.spacing(12),
			width: '100%',
			'& > span > span': {
				textAlign: 'left',
				lineHeight: 1.1,
				fontSize: theme.typography.h4.fontSize,
				fontWeight: theme.typography.h4.fontWeight,
			},

			'&:before': {
				content: 'attr(data-number)',
				marginRight: theme.spacing(4),
				fontSize: theme.typography.h4.fontSize,
				fontWeight: theme.typography.h4.fontWeight,
			},
			'&:hover': {
				backgroundColor: theme.palette.background.default,
				opacity: 1,
			},
			'&:focus': {
				boxShadow: 'none',
				opacity: 1,
			},
		},
	}),
	{ name: 'CallToAction-Cta14-Item' },
)

export default useStyles
